import { DefaultLayout } from "ui/pages/layouts/DefaultLayout";
import { RouteObject } from "react-router-dom";
import { Home } from "ui/pages/app/home/Home";
import {
  accountLoader,
  changePersonalInfosLoader,
  contactLoader,
  createSeanceLoader,
  favoritesLoader,
  homeLoader,
  myCreationsLoader,
  seancesLoader,
  techniquesLoader,
  tutorialsLoader,
  visualSupportsLoader,
} from "ui/navigation/routes/app/appLoaders";
import { SeancesContainer } from "ui/pages/app/seances/SeancesContainer";
import { CreateSeance } from "ui/pages/app/seances/create-seance/CreateSeance";
import { MyCreations } from "ui/pages/app/my-creations/MyCreations";
import { Account } from "ui/pages/app/account/Account";
import { Favorites } from "ui/pages/app/favorites/Favorites";
import { ChangePassword } from "ui/pages/app/account/ChangePassword";
import { ChangePersonalInfos } from "ui/pages/app/account/ChangePersonalInfos";
import { ChangeEmail } from "ui/pages/app/account/ChangeEmail";
import { TechniquesContainer } from "ui/pages/app/techniques/TechniquesContainer";
import TutorialsContainer from "ui/pages/app/tutorials/TutorialsContainer";
import { VisualSupportsContainer } from "ui/pages/app/visual-supports/VisualSupportsContainer";
import { ChooseAccountType } from "ui/pages/auth/ChooseAccountType";
import { AuthLayout } from "ui/pages/layouts/AuthLayout";
import { QuoteRequest } from "ui/pages/auth/register/QuoteRequest";
import { Contact } from "ui/pages/app/contact/Contact";

export const appRoutes: RouteObject[] = [
  {
    index: true,
    loader: homeLoader,
    element: (
      <DefaultLayout>
        <Home />
      </DefaultLayout>
    ),
  },
  {
    path: "/techniques",
    loader: techniquesLoader,
    element: (
      <DefaultLayout>
        <TechniquesContainer />
      </DefaultLayout>
    ),
  },
  {
    path: "/seances",
    loader: seancesLoader,
    element: (
      <DefaultLayout>
        <SeancesContainer />
      </DefaultLayout>
    ),
  },
  {
    path: "/create-seance",
    loader: createSeanceLoader,
    element: (
      <div className="bg-darkGrey-100">
        <CreateSeance />
      </div>
    ),
  },
  {
    path: "/my-creations",
    loader: myCreationsLoader,
    element: (
      <DefaultLayout>
        <MyCreations />
      </DefaultLayout>
    ),
  },
  {
    path: "/account",
    loader: accountLoader,
    element: <Account />,
  },
  {
    path: "/favorites",
    loader: favoritesLoader,
    element: (
      <DefaultLayout>
        <Favorites />
      </DefaultLayout>
    ),
  },
  {
    path: "/change-password",
    loader: changePersonalInfosLoader,
    element: <ChangePassword />,
  },
  {
    path: "/change-personal-infos",
    loader: changePersonalInfosLoader,
    element: <ChangePersonalInfos />,
  },
  {
    path: "/change-email",
    loader: changePersonalInfosLoader,
    element: <ChangeEmail />,
  },
  {
    path: "/tutorials",
    loader: tutorialsLoader,
    element: (
      <DefaultLayout>
        <TutorialsContainer />
      </DefaultLayout>
    ),
  },
  {
    path: "/visual-supports",
    loader: visualSupportsLoader,
    element: (
      <DefaultLayout>
        <VisualSupportsContainer />
      </DefaultLayout>
    ),
  },
  {
    path: "/change-account-type",
    element: (
      <AuthLayout>
        <ChooseAccountType />
      </AuthLayout>
    ),
  },
  {
    path: "/send-quote-request",
    element: (
      <AuthLayout>
        <QuoteRequest />
      </AuthLayout>
    ),
  },
  {
    path: "/contact-innizio",
    loader: contactLoader,
    element: (
      <DefaultLayout>
        <Contact />
      </DefaultLayout>
    ),
  },
];
